import styled from "styled-components";

export const TopView = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 ${({ theme }) => theme.spacing.x_medium }px;
  min-height: 52px;
  margin-bottom: ${({ theme }) => theme.spacing.x_medium }px;
  padding-bottom: ${({ theme }) => theme.spacing.xxx_small }px;
  border-bottom: 1px solid ${({ theme }) => theme.glass.border };

  & > h2 {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  @media (max-width: 768px) {
    align-items: stretch;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xxx_small }px;
    padding: 0 ${({ theme }) => theme.spacing.xx_small }px ${({ theme }) => theme.spacing.xxx_small }px;
  }
`;
